// NotificationCenter.js
import React, { useState, useEffect } from "react";
import NotificationBell from "./NotificationBell";
import NotificationList from "./NotificationList";
import notificationService from "../../services/NotificationService";

const NotificationCenter = ({
  size = "medium",
  showMarkAllAsRead = true,
  maxHeight = "400px",
  className = "",
  onNotificationClick = null,
}) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize notification service when component mounts
    const initializeService = async () => {
      try {
        const initialized = await notificationService.initialize();
        setIsInitialized(initialized);
      } catch (error) {
        console.error("Failed to initialize notification service:", error);
        // Set as initialized anyway to show the component
        setIsInitialized(true);
      }
    };

    initializeService();

    // Cleanup subscriptions when component unmounts
    return () => {
      notificationService.cleanup();
    };
  }, []);

  const handleBellClick = () => {
    if (onNotificationClick) {
      onNotificationClick();
    }
    setIsListOpen(true);
  };

  const handleListClose = () => {
    setIsListOpen(false);
  };

  // Only render if service is initialized
  if (!isInitialized) {
    // Show a simple bell icon while initializing
    return (
      <div className={`notification-center ${className}`}>
        <div
          style={{
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
            padding: "8px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#4c4949da"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`notification-center ${className}`}
      style={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        minWidth: "24px",
        minHeight: "24px",
      }}
    >
      <NotificationBell size={size} onNotificationClick={handleBellClick} />

      <NotificationList
        isOpen={isListOpen}
        onClose={handleListClose}
        maxHeight={maxHeight}
        showMarkAllAsRead={showMarkAllAsRead}
      />
    </div>
  );
};

export default NotificationCenter;
